// extracted by mini-css-extract-plugin
module.exports = {"shippingAddress":"ShippingAddress_shippingAddress__2-vtj","subHeading":"ShippingAddress_subHeading__lsciq","Checkbox":"ShippingAddress_Checkbox__RwKu8"};